const dropDown       = document.getElementById( 'mainMenuDropdown' ) 
const subMenuButtons = document.querySelectorAll( '#mainMenuDropdown .sub-menu-button' )
const mainMenuButton = document.getElementById( 'mainMenuButton' )
const mainMenuNav    = document.getElementById( 'mainMenuNav' )
const documentBody   = document.querySelector( 'body' )

const CONFIG = {
    isTransitioning: false,
    transitionTimeout: null,
    duration: 250
}


const init = function() {

    addEventListeners()

}


const addEventListeners = function() {

    mainMenuButton.addEventListener( 'click', () => {

        if ( CONFIG.isTransitioning ) return

        CONFIG.isTransitioning = true

        const nextExpand = getNextExpandStatus()

        if ( nextExpand ) {
            openMenu()
        } else {
            closeMenu()
        }

    } )

    document.addEventListener( 'keydown', function( event ) {
        
        if ( event.key === "Escape" || event.keyCode === 27 ) {
            clearTimeout( CONFIG.transitionTimeout )
            closeMenu()
        }

    } )

    document.addEventListener( 'click', function( event ) {
        if ( !dropDown.contains( event.target ) && !mainMenuButton.contains( event.target ) ) {
            closeMenu()
        }
    } )

    if ( subMenuButtons ) {
        subMenuButtons.forEach( button => {
            button.addEventListener( 'click', () => toggleSubmenu( button ) )
        } )
    }

}


const toggleSubmenu = function( button ) {

    if ( CONFIG.isTransitioning ) return

    CONFIG.isTransitioning = true

    const parent = button.closest( 'li' )
    const subMenuWrap = parent.querySelector( '.sub-menu-wrap' )
    const expanded = button.getAttribute('aria-expanded')

    if ( expanded === 'true' ) {

        subMenuWrap.classList.remove( 'is-open' )
        button.setAttribute( 'aria-expanded', 'false' )
        
        CONFIG.transitionTimeout = setTimeout( () => {
            subMenuWrap.style.display = 'none'
            CONFIG.isTransitioning = false
        }, CONFIG.duration )

    } else {

        subMenuWrap.removeAttribute( 'style' )

        CONFIG.transitionTimeout = setTimeout( () => {
            subMenuWrap.classList.add( 'is-open' )
            button.setAttribute( 'aria-expanded', 'true' )
            CONFIG.isTransitioning = false
        }, 10 )

    }

}


const getNextExpandStatus = function() {

    const expanded = mainMenuButton.getAttribute( 'aria-expanded' ) === 'true' ? false : true

    return expanded

}


const closeMenu = function() {

    mainMenuNav.classList.add( 'animate-out' )
    mainMenuButton.classList.remove( 'is-expanded' )

    CONFIG.transitionTimeout = setTimeout( () => {
        CONFIG.isTransitioning = false
        mainMenuButton.setAttribute( 'aria-expanded', false )
        mainMenuNav.classList.remove( 'animate-out' )
        documentBody.classList.remove( 'show-header-bar' )
    }, CONFIG.duration )

}


const openMenu = function() {

    documentBody.classList.add( 'show-header-bar' )
    mainMenuButton.setAttribute( 'aria-expanded', true )
    mainMenuButton.classList.add( 'is-expanded' )

    CONFIG.transitionTimeout = setTimeout( () => {
        CONFIG.isTransitioning = false
    }, CONFIG.duration )

}


const api = {
    init: init
}


export default api;
